import styled from '@emotion/styled';
import { Magnetic } from '../../styles';
export const DocumentContainer = styled.div `
	width: 100%;
	height: ${(props) => props.isLoading && props.shouldDisplaySpinner ? '100%' : ''};
	position: absolute;
	overflow: hidden;

	.document-page {
		text-align: center;
	}

	svg {
		width: 100%;
		height: auto;
	}

	canvas,
	.react-pdf__Page__svg {
		width: 90% !important;
		height: auto !important;
		display: inline-block !important;
		box-shadow: ${Magnetic.boxShadow01};
		margin: ${Magnetic.spacer08} 0;
	}
`;
export const ThumbContainer = styled.div `
	height: 100%;
	.thumnail-inner {
		height: 100%;
		margin: auto;
		cursor: default;
	}
`;
export const StyledDocumentViewProgressCircleContainer = styled.div `
	height: 100%;
	width: 100%;
	top: 50%;
`;
export const StyledDocumentAndPageContainer = styled.div `
	display: ${(props) => props.isLoading && props.shouldDisplaySpinner ? 'none' : ''};
	user-select: none;
`;
//# sourceMappingURL=style.js.map